import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { Tracker } from '../models/tracker';
import { TrackerPair } from '../models/trackerpair';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class TrackerService {

  private trackerApiUrl: string;
  private trackerPairApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.trackerApiUrl = this.appSettings.DB_API_ENDPOINT + 'trackers/';
    this.trackerPairApiUrl = this.appSettings.DB_API_ENDPOINT + 'tracker_pairs/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllTrackers(): Promise<Array<Tracker>> {
    return  this.http.get(this.trackerApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }
  public getAvailableForUseTrackers(): Promise<Array<Tracker>> {
    return  this.http.get(this.trackerApiUrl + 'available_for_use', this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addTracker(editingTracker): Observable<any> {
    return this.http.post(this.trackerApiUrl, editingTracker, this.appSettings.apiOptions)
     .map(this.getDataInJson);
  }

  public delTracker(deviceId) {
    return this.http.delete(this.trackerApiUrl + deviceId, this.appSettings.apiOptions);
  }

  public editTracker(editingTracker) {
    return this.http.put(this.trackerApiUrl + editingTracker._id, editingTracker, this.appSettings.apiOptions);
  }

  public getAllTrackerPair(): Promise<Array<TrackerPair>> {
    return  this.http.get(this.trackerPairApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public getAvailableTrackerPair() {
    return this.http.get(this.trackerPairApiUrl + 'available').toPromise().then(this.getDataInJson);
  }

  public addTrackerPair(editTrackerPair) {
    return  this.http.post(this.trackerPairApiUrl, editTrackerPair, this.appSettings.apiOptions)
                .map(this.getDataInJson);
  }

  public delTrackerPair(pairId) {
    return this.http.delete(this.trackerPairApiUrl + pairId, this.appSettings.apiOptions);
  }

  public editTrackerPair(oldPairId, editTrackerPair) {
    return this.http.put(this.trackerPairApiUrl + oldPairId, editTrackerPair, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/tracker.service.ts